/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { log } from 'utils/logger';
import {
    ADVANCE_FRAME,
    ADVANCE_MULTIPLE_FRAMES,
    SET_TOTAL_FRAME_COUNT,
    ACTIVATE_CONTENT,
    ACTIVATE_INJECTABLE_CONTENT,
    SET_INJECTED_ID,
    PAUSE_MULTIPLE_CONTENTS,
    RESUME_MULTIPLE_PAUSED_CONTENTS,
    UNPAUSE_CONTENT,
    DEACTIVATE_CONTENT,
    DEACTIVATE_CONTENTS,
    REMOVE_INJECTED_CONTENT_ID,
    SET_UNIQUE_STATE,
    SET_UNIQUE_FRAME_STATUS,
    ADVAVCE_FRAME_WITH_STATUS,
    UPDATE_CONTENT_STATUS,
    SET_QUESTION_RESPONSE_RESULT,
    SET_ANSWER_CLICKED,
    SET_QUESTION_RESPONSE_ERROR,
    SET_STORY_RESPONSE_RESULT,
    SET_STORY_RESPONSE_FAIL,
    RECEIVE_UDC_SETTINGS,
    RECEIVE_UDC_RESPONSE
} from 'redux/actions/content_status';



/* ========== ~~~~~~~~~~ CONTENT STATUS : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application statea
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const contentStatus = (state = {}, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case ADVANCE_FRAME:
            let newContent = Object.assign({}, newState[action.contentId], {
              frame: newState[action.contentId].paused ? newState[action.contentId]['frame'] : newState[action.contentId]['frame'] += 1
              // done to prevent manual frame advancement via user action like skip ... another check is done inside frame component itself for timer based frame advancement
            });
            return Object.assign({}, newState, { [action.contentId]: newContent});

        case ADVANCE_MULTIPLE_FRAMES:
            newContent = Object.assign({}, newState[action.contentId], {
                frame: newState[action.contentId].paused ? newState[action.contentId]['frame'] : newState[action.contentId]['frame'] += action.numOfFrames
                // done to prevent manual frame advancement via user action like skip ... another check is done inside frame component itself for timer based frame advancement
            });
            return Object.assign({}, newState, { [action.contentId]: newContent});

        case UPDATE_CONTENT_STATUS:
            const uniqueStateData = getFrameStatus(action.data, action.isPQ);
            newState[action.contentId]['uniqueState'] = uniqueStateData;
            newState[action.contentId]['totalFrameCount'] = Object.keys(uniqueStateData.frameStatus).length;
            log('UPDATE_CONTENT_STATUS', newState);
            return newState;

        case SET_ANSWER_CLICKED:
            newState[action.contentId].uniqueState.frameStatus[action.frame].state = 'clicked';
            newState[action.contentId].uniqueState.chosenAnswers[action.frame] = action.optionUUID;
            newState[action.contentId].clearTimeout = true;
            log('SET_ANSWER_CLICKED', newState);
            return newState;


        case SET_QUESTION_RESPONSE_RESULT:
            // newState[action.contentId]['uniqueState']['frameStatus'][action.frame]
            log(SET_QUESTION_RESPONSE_RESULT, action);
            const frameStatus = newState[action.contentId].uniqueState.frameStatus[action.frame];
            newState[action.contentId].uniqueState.frameStatus[action.frame] = setFrameStatusResult(frameStatus, action.result, action.isFactualQuestion);
            return newState;

        case SET_QUESTION_RESPONSE_ERROR:
            newState[action.contentId].uniqueState.frameStatus[action.frame]['state'] = 'networkError';
            return newState;

        case SET_STORY_RESPONSE_RESULT:
            log(SET_STORY_RESPONSE_RESULT, action);
            newState[action.contentId].uniqueState.frameStatus[action.frame].state = 'engaged';
            return newState;
        case SET_STORY_RESPONSE_FAIL:
            newState[action.contentId].uniqueState.frameStatus[action.frame]['state'] = 'networkError';
            return newState;
        case SET_TOTAL_FRAME_COUNT:
            newContent = Object.assign({}, newState[action.contentId], {
                totalFrameCount: action.totalFrameCount
            });
            return Object.assign({}, newState, { [action.contentId]: newContent});

        case ACTIVATE_CONTENT:
            newContent = Object.assign({}, newState[action.contentId], { status: 'active' });
            return Object.assign({}, newState, { [action.contentId]: newContent});

        case ACTIVATE_INJECTABLE_CONTENT:
            // PART I. Set injectable status to active and set parentContentId.
            const newInjectableContent = Object.assign({}, newState[action.injectableContentId], {
              status: 'active',
              parentContentId: action.parentContentId,
              frame: 0
            });
            let updatedState = Object.assign({}, newState, { [action.injectableContentId]: newInjectableContent });
            // PART II. Add injectable's id to parent's array of currently active injectables
            let newInjectablesAtFrame = newState[action.parentContentId]['injectablesAtFrame'];
            let parentFrame = newState[action.parentContentId].frame;
            if (newInjectablesAtFrame[parentFrame]) {
                newInjectablesAtFrame[parentFrame].push(action.injectableContentId);
            } else {
                newInjectablesAtFrame[parentFrame] = [action.injectableContentId];
            }
            let newParentContent = Object.assign({}, newState[action.parentContentId], { injectablesAtFrame: newInjectablesAtFrame });
            updatedState = Object.assign({}, updatedState, { [action.parentContentId]: newParentContent });

            let newInjectedContentIds = newState[action.parentContentId]['injectedContentIds'].slice();
            newInjectedContentIds.push(action.injectableContentId);
            newParentContent = Object.assign({}, newState[action.parentContentId], { injectedContentIds: newInjectedContentIds });
            // Merge changes made to parent's and injectable's states into contentStatus slice of state.
            return Object.assign({}, updatedState, { [action.parentContentId]: newParentContent });

        case SET_INJECTED_ID:
            if (action.injectableType === 'content') { log("ILLIGAL OPERATION"); break; }
            let newInjectedLayoutIds = newState[action.parentContentId]['injectedLayoutIds'].slice();
            newInjectedLayoutIds.push(action.injectableId);
            newContent = Object.assign({}, newState[action.parentContentId], { injectedLayoutIds: newInjectedLayoutIds });
            updatedState = Object.assign({}, newState, { [action.parentContentId]: newContent});

            newInjectablesAtFrame = newState[action.parentContentId]['injectablesAtFrame'];
            parentFrame = newState[action.parentContentId].frame;
            if (newInjectablesAtFrame[parentFrame]) {
                newInjectablesAtFrame[parentFrame].push(action.injectableId);
            } else {
                newInjectablesAtFrame[parentFrame] = [action.injectableId];
            }
            newParentContent = Object.assign({}, updatedState[action.parentContentId], { injectablesAtFrame: newInjectablesAtFrame });
            updatedState = Object.assign({}, updatedState, { [action.parentContentId]: newParentContent });
            return updatedState;

        case RESUME_MULTIPLE_PAUSED_CONTENTS:
          for (let [contentId, pauseStatus] of Object.entries(action.pauseState)) {
              newContent = Object.assign({}, newState[contentId], { paused: pauseStatus });
              newState = Object.assign({}, newState, { [contentId]: newContent });
          }
          return newState;

        case PAUSE_MULTIPLE_CONTENTS:
          action.contentIds.forEach(contentId => {
              newContent = Object.assign({}, newState[contentId], { paused: true });
              newState = Object.assign({}, newState, { [contentId]: newContent });
          });
          return newState;

        case DEACTIVATE_CONTENT:
            newContent = Object.assign({}, newState[action.contentId], {
                status: 'inactive',
                parentContentId: null,
                injectedWithDisplayType: null,
                injectedWithPauseType: null,
                injectAtFrame: null,
                repeatEveryXFrames: null,
                frame: 0,
                totalFrameCount: 0,
            });
            return Object.assign({}, newState, { [action.contentId]: newContent});

        case DEACTIVATE_CONTENTS:
          // deactivate contents and remove their ids from parents injectable list for injectable contents
          for (let contentId of action.contentIds) {
            newContent = Object.assign({}, newState[contentId], {
                status: 'inactive',
                parentContentId: null,
                injectedWithDisplayType: null,
                injectedWithPauseType: null,
                injectAtFrame: null,
                repeatEveryXFrames: null,
                frame: 0,
                totalFrameCount: 0,
            });
            newState = Object.assign({}, newState, { [contentId]: newContent});
            let parentContentId = state[contentId]['parentContentId'];
            if (parentContentId) {
              let parentContent = Object.assign({}, newState[parentContentId], { injectedContentIds: removeElement(newState[parentContentId]['injectedContentIds'], contentId) });
              newState = Object.assign({}, newState, { [parentContentId]: parentContent });
            }
          }
          return newState;

        case REMOVE_INJECTED_CONTENT_ID:
              newContent = Object.assign({}, newState[action.parentContentId], { injectedContentIds: removeElement(newState[action.parentContentId]['injectedContentIds'], action.injectableContentId) });
              return Object.assign({}, newState, { [action.parentContentId]: newContent});

        case SET_UNIQUE_STATE:
          const uniqueState = Object.assign({}, newState[action.contentId]['uniqueState'], action.uniqueState);
          newContent = Object.assign({}, newState[action.contentId], { uniqueState });
          return Object.assign({}, newState, { [action.contentId]: newContent});

        case SET_UNIQUE_FRAME_STATUS:
          log('SET_UNIQUE_FRAME_STATUS ++++++ cleared')
          return newState;

        case ADVAVCE_FRAME_WITH_STATUS:
          newState[action.contentId].uniqueState.frameStatus[newState[action.contentId]['frame']] = action.frameStatus;
          newState[action.contentId].uniqueState.chosenAnswers[newState[action.contentId]['frame']] = action.predictionOptionUUID;
          newContent = Object.assign({}, newState[action.contentId], {
              frame: newState[action.contentId].paused ? newState[action.contentId]['frame'] : newState[action.contentId]['frame'] += 1
              // done to prevent manual frame advancement via user action like skip ... another check is done inside frame component itself for timer based frame advancement
          });
          return Object.assign({}, newState, { [action.contentId]: newContent});


        case RECEIVE_UDC_SETTINGS:
            if (action.data === null || action.data.constructor === Object && Object.keys(action.data).length === 0) {
                newState[action.contentId].uniqueState.phase = 'rejected';
                newState[action.contentId]['totalFrameCount'] = 0;
                return newState;
            }
            const settings = action.data;
            const phase = 'entry';
            const { contentSignature, contentProperties, id } = settings;
            newState[action.contentId]['totalFrameCount'] = 1;
            newState[action.contentId]['uniqueState'] = { phase, contentSignature, contentProperties, udcId: id };
            return newState;

        case RECEIVE_UDC_RESPONSE:
            const { contentId, response, skip } = action;
            if (skip) {
                newState[contentId].frame += 1;
                return newState;
            }
            let newPhase = response !== null && response.validRequest ? 'success' : 'failure';
            if(response.validRequest === false && response.reason === 'Duplicated email') newPhase = 'entry';
            newState[contentId].uniqueState.phase = newPhase;
            return newState;
        default:
            return state;
    }
};

const removeElement = (array, element) => {
    let result = array.slice();
    let index = array.indexOf(element);
    if (index > -1) {
        result.splice(index, 1);
    }
    return result;
};

const getFrameStatus = (data, isPQ) => {
    const frameStatus = {};
    const chosenAnswers = {};
    const contentData = isPQ ? _getAllQuestionnairesQuestions(data) : data;
    contentData.forEach((frame, idx) => {
        frameStatus[idx] = {
            state: 'initial',
            validRequest: null,
            options: {},
            isAnsweredCorrectly: null
        };
        //TODO this ternary is here for profilling questions still using the old structure, WILL BE UPDATED IN THE FUTURE
        let answers = isPQ ? frame.answers : !!frame.contentProperties && !!frame.contentProperties.answers ? frame.contentProperties.answers : null;
        if (!!answers) answers.forEach(answer => frameStatus[idx]['options'][answer.id] = {
            numOfTimesChosen: 0,
            isCorrect: null
        });
        chosenAnswers[idx] = null;
    });
    return { frameStatus, chosenAnswers };
};

const _getAllQuestionnairesQuestions = data => {
    const allQuestion = [];
    data.forEach(questionnaire => {
        questionnaire.questions.forEach(question => {
            allQuestion.push(question)
        })
    });
    return allQuestion;
};

const setFrameStatusResult = (frameStatus, result, isFactualQuestion) => {
    let newFrameStatus = JSON.parse(JSON.stringify(frameStatus));
    newFrameStatus.validRequest = result.validRequest;
    newFrameStatus.state = 'result';
    newFrameStatus = newFrameStatus.validRequest ? validRequest(newFrameStatus, result, isFactualQuestion) : invalidRequest(newFrameStatus);
    return newFrameStatus
};

const validRequest = (newFrameStatus, result, isFactualQuestion) => {
    newFrameStatus.isAnsweredCorrectly = result.correctAnswer !== undefined ? result.correctAnswer : null;
    if (!!result.options) for (let [optionId, numOfTimesChosen] of Object.entries(result.options)) {
        if (newFrameStatus.options[optionId] !== undefined) newFrameStatus.options[optionId]['numOfTimesChosen'] = numOfTimesChosen;
    }
    if(isFactualQuestion) newFrameStatus.options[result.answerUUID]['isCorrect'] = true;

    return newFrameStatus;
};

const invalidRequest = (frameStatus) => {
    frameStatus['state'] = 'networkError';
    return frameStatus;
};



//
// {
//     "validRequest":true,
//     "answerUUID":"bfd1339b-713e-4420-922a-5629b8991cd3",
//     "options":{
//     "853a17ea-fe7e-407a-9345-09d44588aa65":1
// },
//     "correctAnswer":false
// }

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default contentStatus;
